

export enum PopulateType {
	DateOfEvent = 1,
	ValueInField = 2,
	LatestOfValuesInDateTriggers = 3,
	EarliestOfValuesInDateTriggers = 4
}